const backendApi = {
  invalidUserData: 'invalid user data',
} as const;

export default backendApi;
